<div class="background">
  <div class="error-box">
    <div fxLayout="column">
      <div fxLayout="row">
        <div fxFlex></div>
        <app-progressbar [step]="1" [maxStep]="1"></app-progressbar>
      </div>
      <div class="content">
        <span class="title">{{ 'ERROR.TITLE' | translate }}</span>
        <p>{{ errorText }}</p>
        <p>
          <i>{{ extraMessage |json }}</i>
        </p>
      </div>
    </div>
  </div>
</div>
